import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

interface PurchaseClaimsRequestParams {
  period_from?: string;
  period_to?: string;
  platform_ids?: string;
  company_id?: string;
  activation_order_id?: string;
  purchase_request_id?: string;
  currency?: string;
}

export interface PurchaseClaimsParams {
  resultKey?: string;
  successCallback?: Function;
  errorCallback?: Function;
  params?: PurchaseClaimsRequestParams;
}

export default ({ resultKey = 'purchaseDataClaims', successCallback, errorCallback, params }: PurchaseClaimsParams) =>
  requestAsync({
    url: endpoints.getPurchaseClaimsUrl(params),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getPurchaseClaimsUrl(params),
    meta: {
      successCallback,
      errorCallback,
      authToken: true,
    },
    options: {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
